import Skeleton from "react-loading-skeleton";
import React from "react";
const SkeletonCustomerBalance = ({}): JSX.Element => {
    const GLOBAL_PREFIX: string = "loy-bpo-balance-v2";
    return (
        <div className={`${GLOBAL_PREFIX}`}>
            <Skeleton style={{borderRadius: "5px 50px 5px 5px"}} height={73}/>
        </div>
    )
}
export default SkeletonCustomerBalance;
